// extracted by mini-css-extract-plugin
module.exports = {"PricingRulesContent":"PricingRulesPage_PricingRulesContent__27vrG"};